export const queryKeys = {
  ME: "me",
  ME_CAMPS: "me-camps",
  ME_CAMPING_STYLES: "me-campingStyles",
  PRODUCTS: "products",
  COUPONS: "coupons",
  AUTOMATED_MESSAGES: "automated-messages",
  RESERVATION_PREVIEWS: "reservation-previews",
  ORDER: "order",
  ORDERS: "orders",
  HISTORY: "history",
  RESERVATION: "reservation",
  RESERVATIONS: "reservations",
  CAMPER: "camper",
  CAMP: "camp",
  SITES: "sites",
  ORDER_INVOICE: "order-invoice",
  DYNAMIC_FORMS_SCHEMA: "dynamic-forms-schema",
  DYNAMIC_FORMS_RESOURCE_INDEX: "dynamic-forms-resource-index",
  DYNAMIC_FORMS_RESOURCE_SHOW: "dynamic-forms-resource-show",
  
}
